export default "__VITE_ASSET__fy2VI8yv__"